<ng-container>
  <div class="pinned">
    @if (title) {
      <h1>{{ title | translate }}</h1>
    }
    @if (!disabled && canAdd) {
      <div class="buttons">
        <button nbButton type="button" (click)="newItem()" shape="semi-round" size="small" status="primary">
          <nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'additem' | translate:{value: subtitle} }}
        </button>
      </div>
    }
  </div>
  <bst-dual-axis [delegate]="this" [bootstrap]="false"></bst-dual-axis>
</ng-container>

<ng-template #cellTemplate let-row="row" let-column="column" let-node="node">
  @if (row[column.name] || column.display) {
    @if (column.display) {
      @if (isTemplate(column)) {
        <ng-container [ngTemplateOutlet]="column.display" [ngTemplateOutletContext]="{col: column, row: row, display: true}"></ng-container>
      }
      @if (!isTemplate(column)) {
        <span>{{ column.display.call(this, row[column.name]) }}</span>
      }
    }
    @if (!column.display) {
      @if (column.type === ColType.BOOL) {
        <span class="center">
          @if (row[column.name]) {
            <nb-icon icon="checkmark-outline"></nb-icon>
          }
        </span>
      }
      @if ((column.type === ColType.SELECT || column.type === ColType.RADIO) && column.list) {
        <span>
          {{ displayFor(row[column.name], column) }}
        </span>
      }
      @if (column.type === ColType.DATE) {
        <span>
          {{ row[column.name] | dateify | date:'longDate' }}
        </span>
      }
      @if (column.type === ColType.RANGE) {
        <span>
          {{ row[column.name].start | dateify | date:'longDate'}} - {{ row[column.name].end | dateify | date:'longDate' }}
        </span>
      }
      @if (column.type === ColType.LOCATION
        || column.type === ColType.STRING
        || column.type === ColType.CUSTOM
        || column.type === ColType.INT
        || column.type === ColType.AREA) {
        <span>
          {{ row[column.name] }}
        </span>
      }
    }
  }
</ng-template>
